import { Component, Input } from '@angular/core';
import { CountdownData, THIRTY_MINUTES_IN_MILLISECONDS } from '../../../services/schedule.service';

@Component({
	selector: 'sp-period-countdown',
	templateUrl: './period-countdown.component.html',
	styleUrls: ['./period-countdown.component.scss'],
})
export class PeriodCountdownComponent {
	@Input() countdownData: CountdownData;

	protected readonly thirtyMinutesInMilliseconds = THIRTY_MINUTES_IN_MILLISECONDS;
}
